import { AutomationsPresentationV1 } from 'Automations/automationEditor'
import { SendReminder } from 'Automations/nodeDefinitions/definitions/reminder'
import {
  DEFAULT_REMINDER_RECIPIENTS,
  DEFAULT_REMINDER_SUBJECT,
  DEFAULT_REMINDER_TEMPLATE
} from 'Automations/nodeDefinitions/definitions/reminder/reminder.template'

const buildDefaultInvoiceSentData = (sendReminder: SendReminder) => ({
  name: '',
  to: DEFAULT_REMINDER_RECIPIENTS,
  cc: [],
  bcc: [],
  subject: DEFAULT_REMINDER_SUBJECT,
  template: DEFAULT_REMINDER_TEMPLATE,
  sendReminder,
  isApprovalRequired: false,
  approverUserIds: []
})

export const INVOICE_SENT_BASE: AutomationsPresentationV1 = {
  version: 1,
  nodes: [
    {
      id: 'c6e5dc67-483f-43b6-8a1c-f58e6c66aff8',
      data: { name: '', trigger: 'INVOICE_SENT' },
      type: 'START_INVOICE_SENT',
      position: { x: -454, y: -18.5 }
    },
    {
      id: 'ff6ee32d-0217-4a09-bc8f-5914317bf53f',
      data: buildDefaultInvoiceSentData({
        type: 'AFTER_DUE_DATE',
        duration: { days: 7 }
      }),
      type: 'REMINDER',
      position: { x: -262, y: -38.5 }
    },
    {
      id: '700b5ea0-b9e9-4aff-a51d-b37eee6e810c',
      data: buildDefaultInvoiceSentData({
        type: 'AFTER_DUE_DATE',
        duration: { days: 14 }
      }),
      type: 'REMINDER',
      position: { x: 44, y: -38.5 }
    },
    {
      id: '60f0280f-9266-4e99-a1c6-4e2a1a832834',
      data: buildDefaultInvoiceSentData({
        type: 'AFTER_DUE_DATE',
        duration: { days: 21 }
      }),
      type: 'REMINDER',
      position: { x: 350, y: -38.5 }
    },
    {
      id: '3354300a-034a-4d99-adf7-2e01b9db82ed',
      data: { name: '' },
      type: 'END',
      position: { x: 651, y: 3.5 }
    }
  ],
  edges: [
    {
      id: 'xy-edge__c6e5dc67-483f-43b6-8a1c-f58e6c66aff8c6e5dc67-483f-43b6-8a1c-f58e6c66aff8:source-ff6ee32d-0217-4a09-bc8f-5914317bf53fff6ee32d-0217-4a09-bc8f-5914317bf53f:target',
      source: 'c6e5dc67-483f-43b6-8a1c-f58e6c66aff8',
      target: 'ff6ee32d-0217-4a09-bc8f-5914317bf53f',
      sourceHandle: 'c6e5dc67-483f-43b6-8a1c-f58e6c66aff8:source',
      targetHandle: 'ff6ee32d-0217-4a09-bc8f-5914317bf53f:target'
    },
    {
      id: 'xy-edge__ff6ee32d-0217-4a09-bc8f-5914317bf53fff6ee32d-0217-4a09-bc8f-5914317bf53f:source-700b5ea0-b9e9-4aff-a51d-b37eee6e810c700b5ea0-b9e9-4aff-a51d-b37eee6e810c:target',
      source: 'ff6ee32d-0217-4a09-bc8f-5914317bf53f',
      target: '700b5ea0-b9e9-4aff-a51d-b37eee6e810c',
      sourceHandle: 'ff6ee32d-0217-4a09-bc8f-5914317bf53f:source',
      targetHandle: '700b5ea0-b9e9-4aff-a51d-b37eee6e810c:target'
    },
    {
      id: 'xy-edge__700b5ea0-b9e9-4aff-a51d-b37eee6e810c700b5ea0-b9e9-4aff-a51d-b37eee6e810c:source-60f0280f-9266-4e99-a1c6-4e2a1a83283460f0280f-9266-4e99-a1c6-4e2a1a832834:target',
      source: '700b5ea0-b9e9-4aff-a51d-b37eee6e810c',
      target: '60f0280f-9266-4e99-a1c6-4e2a1a832834',
      sourceHandle: '700b5ea0-b9e9-4aff-a51d-b37eee6e810c:source',
      targetHandle: '60f0280f-9266-4e99-a1c6-4e2a1a832834:target'
    },
    {
      id: 'xy-edge__60f0280f-9266-4e99-a1c6-4e2a1a83283460f0280f-9266-4e99-a1c6-4e2a1a832834:source-3354300a-034a-4d99-adf7-2e01b9db82ed3354300a-034a-4d99-adf7-2e01b9db82ed:target',
      source: '60f0280f-9266-4e99-a1c6-4e2a1a832834',
      target: '3354300a-034a-4d99-adf7-2e01b9db82ed',
      sourceHandle: '60f0280f-9266-4e99-a1c6-4e2a1a832834:source',
      targetHandle: '3354300a-034a-4d99-adf7-2e01b9db82ed:target'
    }
  ]
}
